module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zdy-head SubmissionResult"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("评价详情")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('icon', {
    attrs: {
      "type": "success",
      "is-msg": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("评价提交成功")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v("返 回")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "gradients": ['#FF9500', '#FF9500']
    },
    nativeOn: {
      "click": function($event) {
        _vm.colse($event)
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed65ed38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/ValuationProject/serviceSubmissionResult.vue
// module id = trvH
// module chunks = 7